import React from 'react';
import { District } from '../types/district';
import AssignDistrictReportTemplatesModal from '@features/report/template/components/AssignDistrictReportTemplatesModal';
import ViewDistrictAssignedTemplatesModal from './ViewDistrictAssignedTemplatesModal';

type Props = {
  show: boolean;
  onHide: () => void;
  district: District | null;
  canManage: boolean;
  nationId?: number;
};

const DistrictTemplatesModal: React.FC<Props> = ({
  show,
  onHide,
  district,
  canManage,
  nationId,
}) => {
  if (canManage) {
    return (
      <AssignDistrictReportTemplatesModal
        show={show}
        onHide={onHide}
        districtId={district?.district_id ?? 0}
        nationId={nationId}
      />
    );
  }

  return (
    <ViewDistrictAssignedTemplatesModal
      show={show}
      onHide={onHide}
      district={district}
    />
  );
};

export default DistrictTemplatesModal;
